import { postDeleteImages } from '../api/POST_DeleteImages';
import { ProductInterface } from '../pages/add-product/index.type';

export const bulkDeleteImages = async (products: Array<ProductInterface>) => {
  const parseProducts = products;
  const images = parseProducts
    .map((product) => product?.images?.map((image) => image?.uuid))
    .flat();
  if (images.length > 0) {
    await postDeleteImages({ uuid: images });
  }
};
